export const footer = ({ primary, secondary }) => {
  return {
    socialNetworks: {
      background: `rgba(${primary}, 1)`,
      color: "#2d3436",
    }
  }
};